import { TaskService } from "@/enums/TaskService";
import { TaskStatus } from "@/enums/TaskStatus";
import { TaskType } from "@/enums/TaskType";
import { TaxesCompanyType } from "@/enums/TaxesCompanyType";
import { CompanyStatus } from "@/types/CompanyStatus";
import { CompanyStatusTag } from "@/types/CompanyStatusTag";
import { FunderType } from "@/types/FunderTypes";
import { ProductService } from "@/types/ProductService";

export namespace EnumsUtils {
  export function parseEnumToRender(
    value: TaskStatus | TaskType | ProductService | CompanyStatusTag | CompanyStatus | FunderType | TaxesCompanyType | string
  ) {
    if (!value) return;
    const r = value.replaceAll("_", " ").replaceAll("-", " ").toLowerCase();
    return r.charAt(0).toUpperCase() + r.substring(1);
  }

  export function parseEnumTaxesToRender(value: TaskService | string) {
    if (!value) return;
    const words = value.split(/[_-]/);
    const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    return capitalizedWords.join(" ");
  }
}
